// components/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const authData = JSON.parse(localStorage.getItem("authData"));
  const isAuthenticated = authData && Date.now() < authData.expiresAt;

  if (!isAuthenticated) {
    return <Navigate to="/password" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
